// Mantine
import { Modal } from '@mantine/core'
import { useListener } from 'react-bus'

// Custom
import WarrantyDisplay from '../warranties/WarrantyDisplay'

// React
import { useEffect, useState } from 'react'

// Router
import { useLocation } from 'react-router-dom'

export default function ScannedModals() {
    const [scanned, setScanned] = useState(null)
    const location = useLocation()

    useEffect(() => {
        setScanned(null)
    }, [location.key])

    useListener('scan', (data) => {
        // If we are not on the warranties association page, we can display the modal
        if (
            data?.type === 'warranty' &&
            location.pathname !== '/warranties/associate' &&
            !location.pathname.startsWith('/fulfillment_orders/')
        ) {
            setScanned(data)
        }
    })

    if (scanned?.type === 'warranty') {
        return (
            <Modal
                opened={scanned !== null && scanned.type === 'warranty'}
                onClose={() => setScanned(null)}
                withCloseButton={false}
                size={900}
            >
                <WarrantyDisplay code={scanned.code} inModal={true} />
            </Modal>
        )
    }

    return null
}
